import React from "react"
import {Form, Space} from "antd"
import {InputNumber, Select, SelectOption} from "ui"
import DiscountType from "../../../../enums/discount-type"
import {useTranslations} from "../hooks/use-translations"

export default function DiscountField() {
  const t = useTranslations()

  return (
    <Form.Item className="discount-select">
      <Space.Compact>
        <InputNumber name="discount_value"
                     min={0}
                     controls={false}
                     label={t("coupons.form.discount")}
                     validations={['required']}/>
        <Form.Item name="discount_type" label="&nbsp;" initialValue={DiscountType.PERCENT}>
          <Select>
            <SelectOption value={DiscountType.PERCENT}>
              {t("coupons.form.discount.percent")}
            </SelectOption>
            <SelectOption value={DiscountType.FIXED}>
              {t("coupons.form.discount.fixed")}
            </SelectOption>
          </Select>
        </Form.Item>
      </Space.Compact>
    </Form.Item>
  );
}